<template>
  <v-data-table
    :headers="_headers"
    :items="transmittals"
    :search="search"
    :loading="loading"
    group-by="programCode"
    sort-by="uploadedAt"
    sort-desc
    item-key="transmittalId"
    v-model="selected"
    show-select
  >
    <template v-if="isProcessed" v-slot:[`top`]>
      <v-toolbar flat>
        <v-btn
          v-for="action in actions"
          :key="action.name"
          small
          :disabled="selected.length == 0"
          color="primary"
          class="mx-1"
          @click="performAction(action)"
          >{{ action.name }}</v-btn
        >
        <confirm-modal ref="confirm"></confirm-modal>
      </v-toolbar>
    </template>
    <template
      v-slot:[`group.header`]="{ group, headers, toggle, isOpen, items }"
      ><td :colspan="headers.length">
        <v-btn @click="toggle" x-small icon :ref="group">
          <v-icon v-if="isOpen">mdi-minus</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
        <span class="mx-5 font-weight-bold text-subtitle-2">
          {{ items[0].programCode }}
        </span>
      </td>
    </template>
    <template v-slot:[`header.data-table-select`]></template>
    <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
      <v-simple-checkbox
        :value="isSelected"
        @input="select($event)"
        :disabled="!Boolean(item.processedAt)"
      ></v-simple-checkbox>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip :color="item.statusColor" label x-small text-color="white">{{
        item.status
      }}</v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        v-if="item.isError"
        text
        color="primary"
        x-small
        @click="reprocess(item)"
        >Reprocess</v-btn
      >
      <resolve-transmittal-dialog
        v-if="item.isError"
        :transmittalId="item.transmittalId"
      ></resolve-transmittal-dialog>
    </template>
  </v-data-table>
</template>
<script>
import ConfirmModal from "../Shared/confirm-modal";
import ResolveTransmittalDialog from "./resolve-transmittal-dialog.vue";
export default {
  props: ["loading", "transmittals", "search", "isProcessed"],
  components: { ConfirmModal, ResolveTransmittalDialog },
  data() {
    return {
      headers: [
        { text: "Id", value: "transmittalId" },
        { text: "Program", value: "programCode" },
        { text: "Semester", value: "semesterCode" },
        { text: "Client", value: "clientName" },
        { text: "OSIS", value: "clientOsis" },
        { text: "School", value: "schoolName" },
        { text: "Service", value: "serviceCode" },
        { text: "Mandate", value: "mandate" },
        { text: "Service Start Date", value: "formattedServiceStartDate" },
        { text: "Status", value: "status" },
        { text: "Message", value: "message" },
        { text: "Actions", value: "actions", hide: this.isProcessed },
      ],
      selected: [],
      actions: [
        {
          name: "Accept",
          path: "acceptTransmittals",
          subtitle:
            "This will create service plan(s) if no matching one(s) exist",
          presentParticiple: "Accepting",
        },
        {
          name: "Reject",
          path: "rejectTransmittals",
          subtitle: "This will remove associated service plan(s) if exist",
          presentParticiple: "Rejecting",
        },
        {
          name: "Revoke",
          path: "revokeTransmittals",
          subtitle: "This will remove associated service plan(s) if exist",
          presentParticiple: "Revoking",
        },
        {
          name: "Refuse",
          path: "refuseTransmittals",
          subtitle: "",
          presentParticiple: "Refusing",
        },
      ],
    };
  },
  computed: {
    _headers() {
      return this.headers.filter((x) => !x.hide);
    },
  },
  methods: {
    async performAction(action) {
      if (
        await this.$refs.confirm.open(
          `${action.name} ${this.selected.length} transmittal(s)?`,
          action.subtitle,
          action.name
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        var message = await this.$store.dispatch(
          "transmittalsModule/" + action.path,
          this.selected.map((t) => t.transmittalId)
        );
        this.$store.commit("uxModule/setShowLoader", false);

        if (message) {
          this.$store.commit(
            "uxModule/setSnackbarMsg",
            `Error ${action.presentParticiple} Transmittal(s): ${message}`
          );
          this.$store.commit("uxModule/setShowSnackbar", true);
        } else {
          this.selected = [];
        }
      }
    },
    async reprocess(transmittal) {
      this.$store.commit("uxModule/setShowLoader", true);
      var message = await this.$store.dispatch(
        "transmittalsModule/reprocessTransmittal",
        { transmittalId: transmittal.transmittalId }
      );
      this.$store.commit("uxModule/setShowLoader", false);

      if (message) {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          `Error Reprocessing Transmittal: ${message}`
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
  },
};
</script>
